var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isSmallScreen)?[_c('menumobile')]:[_c('menudesktop')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }